import { takeLatest } from 'redux-saga/effects';
import {
  getTrainingModuleListSuccess, getTrainingModuleListFail,
  getTrainingModuleDetailsSuccess, getTrainingModuleDetailsFail
} from './trainingModuleState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/training/training-modules');
const redirectData = {route:'/console/training-modules', mode: 'list', recordId:0 };
const modelName = 'Training Modules';
const modelId = 'trm_id';

function* getTrainingModuleList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getTrainingModuleListSuccess, 
		getTrainingModuleListFail, null, null, LOADING_MSG);
}

function* getTrainingModuleDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getTrainingModuleDetailsSuccess, 
		getTrainingModuleDetailsFail, null, null, LOADING_MSG);		
}

function* doTrainingModuleCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getTrainingModuleDetailsSuccess, 
		getTrainingModuleDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: 'reload'},
		SAVING_MSG);
}

function* doTrainingModuleUpdate(data){
	console.log(modelId);
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getTrainingModuleDetailsSuccess, 
		getTrainingModuleDetailsFail,
		updateRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		UPDATING_MSG);	
}

function* doTrainingModuleDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getTrainingModuleDetailsSuccess, 
		getTrainingModuleDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* trainingModulesSaga() {
  yield takeLatest('trainingModule/getTrainingModuleList', getTrainingModuleList);
  yield takeLatest('trainingModule/getTrainingModuleDetails', getTrainingModuleDetails);
  yield takeLatest('trainingModule/doTrainingModuleCreate', doTrainingModuleCreate);
  yield takeLatest('trainingModule/doTrainingModuleUpdate', doTrainingModuleUpdate);
  yield takeLatest('trainingModule/doTrainingModuleDelete', doTrainingModuleDelete);  
}

export default trainingModulesSaga;
